import React from 'react';

import ContactManagementView from '@sophocles/components/contacts/ContactManagementView';

/**
 * SiteGroupContactsTab - Display and manage site group contacts with optional customer contacts
 */
function SiteGroupContactsTab({ customerId, siteGroupId }) {
  // Default to showing only site group contacts (not customer-level)
  return <ContactManagementView customerId={customerId} siteGroupId={siteGroupId} initialScopeFilter="site_group" />;
}

export default SiteGroupContactsTab;
